export const REDACTED_ROUTES = ["/classroom/:token"] as const;
